(function () {
  document.addEventListener('DOMContentLoaded', function () {
    let tooltips = document.querySelectorAll('.tooltip');

    tooltips.forEach(function (tooltip) {
      let tooltipText = tooltip.querySelector('.tooltiptext');
      let tooltipIcon = tooltip.querySelector('.tooltip-icon');

      function showTooltip() {
        tooltipText.setAttribute('aria-hidden', 'false');
        tooltipText.style.visibility = 'visible';
        tooltip.setAttribute('aria-expanded', 'true');
        tooltipIcon.setAttribute('aria-expanded', 'true');
      }

      function hideTooltip() {
        tooltipText.setAttribute('aria-hidden', 'true');
        tooltipText.style.visibility = 'hidden';
        tooltip.setAttribute('aria-expanded', 'false');
        tooltipIcon.setAttribute('aria-expanded', 'false');
      }

      function toggleTooltip() {
        if (tooltipText.getAttribute('aria-hidden') === 'true') {
          showTooltip();
        } else {
          hideTooltip();
        }
      }

      tooltip.addEventListener('mouseover', showTooltip);
      tooltip.addEventListener('focus', showTooltip);
      tooltip.addEventListener('click', toggleTooltip);

      tooltip.addEventListener('mouseout', hideTooltip);
      tooltip.addEventListener('blur', hideTooltip);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          hideTooltip();
        }
      });
    });
  });
})();
